import React from 'react';
import cn from 'classnames';

import Actions from 'components/layout/Actions';

import style from './Menu.module.scss';

const Menu = ({ actions = [], className, disabled }) => {
  return (
    <div className={cn(style.container, className)}>
      <Actions
        items={actions}
        small
        disabled={disabled}
      />
    </div>
  );
};

export default Menu;
